import React from "react";
import { toUrl } from "../../../lib/config";

type AboutIntroProps = {
  // Üst blok (sol metin + sağ logo)
  aboutTitle?: string; // "Megapark Hastanesi"
  aboutText?: string[]; // paragraflar (her biri ayrı satır)
  logoSrc: string;
  logoAlt?: string;

  // Alt blok (kicker + başlık + açıklama)
  valuesKicker?: string; // "BİZİM İÇİN ÖNEMLİSİNİZ"
  valuesTitleGreen?: string; // "Temel"
  valuesTitleMain?: string; // "Değerlerimiz"
  valuesText?: string;

  // Renkler
  green?: string; // "#2ba87a"
  text?: string;  // "#2b2b2b"
  divider?: string; // çizgi rengi "#dcdcdc"
};

const AboutIntro: React.FC<AboutIntroProps> = ({
  // defaults
  aboutTitle = "Megapark Hastanesi",
  aboutText = [],
  logoSrc,
  logoAlt = "Megapark Hastanesi",

  valuesKicker = "BİZİM İÇİN ÖNEMLİSİNİZ",
  valuesTitleGreen = "Temel",
  valuesTitleMain = "Değerlerimiz",
  valuesText = "Hastanemiz hastalarına üst düzey hizmet ve değer vermektedir. Kendinizi değerli hissetmeniz için Megapark Hastanesi her zaman yanınızda.",

  green = "#2ba87a",
  text = "#2b2b2b",
  divider = "#ececec",
}) => {
  const ImgWithFallback: React.FC<{ src?: string; alt?: string; className?: string }> = ({ src, alt, className }) => {
    const input = src || "";
    const raw = /^https?:\/\//i.test(input)
      ? input
      : (input.startsWith('/api/') ? input : (input ? `/api/media/${input}` : ''));
    const abs = /^https?:\/\//i.test(raw) ? raw : toUrl(raw);
    const [current, setCurrent] = React.useState(abs);
    return (
      <img
        src={current}
        alt={alt || ''}
        className={className}
        style={{ maxWidth: 260, width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }}
        crossOrigin="anonymous"
        onError={(e) => {
          const cur = e.currentTarget.getAttribute('src') || '';
          const next = cur === abs ? raw : abs;
          if (next && next !== cur) e.currentTarget.src = next;
        }}
      />
    );
  };
  return (
    <section
      className="about-intro"
      style={
        {
          // @ts-ignore CSS custom properties
          "--ai-green": green,
          "--ai-text": text,
          "--ai-divider": divider,
        } as React.CSSProperties
      }
    >
      <div className="ai-container">
        {/* ÜST BLOK: Sol metin – Sağ logo */}
        <div className="ai-top">
          <div className="ai-copy">
            <h2 className="ai-title">{aboutTitle}</h2>
            <span className="ai-title-underline" />
            {aboutText.length > 0 && (
              <div className="ai-paras">
                {aboutText.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            )}
          </div>

          <div className="ai-logo">
            <ImgWithFallback src={logoSrc} alt={logoAlt} />
          </div>
        </div>

        {/* ALT BLOK: Kicker + Başlık + Açıklama */}
        <div className="ai-bottom">
          <div className="ai-kicker">{valuesKicker}</div>

          <h3 className="ai-values-title">
            <span className="green">{valuesTitleGreen}</span>{" "}
            <span className="main">{valuesTitleMain}</span>
          </h3>
          <span className="ai-values-underline" />

          <p className="ai-values-text">{valuesText}</p>
          
        </div>

      </div>
    </section>
  );
};

export default AboutIntro;
